module.exports = __webpack_public_path__ + "img/compasses.526394fd.png";